import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsWeightTrainingNormalLarge = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M47.25 23.35h-3.18v-3.9a1.52 1.52 0 00-1.52-1.51h-2.83a1.44 1.44 0 00-.51.09v-2.45a1.52 1.52 0 00-1.51-1.51h-2.83a1.52 1.52 0 00-1.51 1.51v7.77H14.7v-7.77a1.52 1.52 0 00-1.52-1.51h-2.82a1.52 1.52 0 00-1.52 1.51V18a1.44 1.44 0 00-.51-.09H5.5A1.52 1.52 0 004 19.45v3.9H.81a.5.5 0 00-.5.5.5.5 0 00.5.5H4v4.2a1.51 1.51 0 001.5 1.51h2.83a1.44 1.44 0 00.51-.06v2.6a1.52 1.52 0 001.52 1.51h2.82a1.52 1.52 0 001.52-1.51v-8.25h18.66v8.22a1.52 1.52 0 001.51 1.51h2.83a1.52 1.52 0 001.51-1.51V30a1.44 1.44 0 00.51.09h2.83a1.51 1.51 0 001.52-1.51v-4.2h3.18a.5.5 0 00.5-.5.51.51 0 00-.5-.53zM8.33 29.06H5.5a.51.51 0 01-.5-.51v-9.1a.51.51 0 01.51-.51h2.82a.51.51 0 01.51.51v9.1a.51.51 0 01-.51.51zm5.37 3.51a.51.51 0 01-.52.51h-2.82a.51.51 0 01-.52-.51v-17a.51.51 0 01.52-.51h2.82a.51.51 0 01.52.51zm24.51 0a.51.51 0 01-.51.51h-2.83a.51.51 0 01-.51-.51v-17a.51.51 0 01.51-.51h2.83a.51.51 0 01.51.51zm4.86-4a.52.52 0 01-.52.51h-2.83a.51.51 0 01-.51-.51v-9.1a.51.51 0 01.51-.51h2.83a.52.52 0 01.52.51z"
  }));
});
SvgSportsWeightTrainingNormalLarge.defaultProps = {
  height: 48,
  width: 48
};
SvgSportsWeightTrainingNormalLarge.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsWeightTrainingNormalLarge;